module.exports = __webpack_public_path__ + "img/average-stay-w.svg";